<template>
  <info-section-card v-loading="isLoading">
    <template v-slot:header>{{L10n('latest-created-invoices')}}</template>
    <div
      class="info-section__content-item"
      v-for="item in listInvoices"
      :key="item.fieldName">
      <div class="d-flex justify-content-between mb-2">
        <div>
          <span class="title">{{item.invoiceNumber}}  </span>
        </div>
        <button
          type="button"
          class="btn btn-size-xs"
          @click="handleGoTo({ id: item.id })"
        >
          {{L10n('go')}}
        </button>
      </div>
    </div>
  </info-section-card>
</template>

<script>
import { ServiceInvoice } from '@/services/Invoice'

export default {
  name: 'LatestInvoices',
  components: {
    'info-section-card': () => import(/* webpackChunkName: 'InfoSection' */ '@/components/InfoSection/Card.vue')
  },
  data () {
    return {
      isLoading: false,
      listInvoices: []
    }
  },
  mounted () {
    this.$bus.$on('on-click-tab-invoice', this.loadInvoices)
  },
  beforeDestroy () {
    this.$bus.$off('on-click-tab-invoice', this.loadInvoices)
  },
  methods: {
    handleGoTo ({ id }) {
      this.$router.push({ name: 'Invoices', query: { 'invoices': `edit[${id}]` } })
    },
    async loadInvoices () {
      this.isLoading = true
      try {
        const { data } = await ServiceInvoice
          .getAllDynamic({ take: 5, select: 'id,invoiceNumber', orderBy: 'id desc', filter: 'invoiceTypeID == 3 || invoiceTypeID == 7' })
        this.listInvoices = data.value
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
